// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".clear-dates[data-v-1fa41ce0]{align-items:flex-start;display:inline-flex;justify-content:center;margin:4em 0 0;position:absolute}.clear-dates button[data-v-1fa41ce0]{font-size:var(--body)}button .icon[data-v-1fa41ce0]{height:1.2em;margin:0 .1em 0 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
